module.exports = __webpack_public_path__ + "3b2a3eedd3238965d0a972ae1d452066.svg";